import React from 'react'
import Enquiry from '../Component/Enquiry'

const Enquirry = () => {
  return (
    <div>
      <Enquiry/>
    </div>
  )
}

export default Enquirry
